/**
 * @method storageAPI
 * @description Util to access storage API
 * @param {string} storageType define type of storage need to be used. by default use sessionStorage
 */
const storageAPI = (storageType = 'sessionStorage') => ({
  /**
   * setItem
   * @param {string} key sessionStorage key name
   * @param {*} value data to be stored in the key
   */

  setItem: (key, value) => {
    if (value === undefined) {
      window[storageType].removeItem(key);
      return;
    }

    window[storageType].setItem(key, typeof value === 'string' ? value : JSON.stringify(value));
  },

  /**
   * setItems
   * @param {object} item object containing key value pairs to be stored in storageType.
   */
  setItems: item => Object.keys(item).forEach(key => window[storageType].setItem(key, JSON.stringify(item[key]))),
  /**
   * getItem
   * @param {string} key sessionStorage key name
   */
  getItem: key => {
    const data = window[storageType].getItem(key);

    if (!data || data === 'undefined') {
      return null;
    }

    try {
      return JSON.parse(data);
    } catch {
      return data;
    }
  },

  /**
   * removeItem
   * @param {string} key sessionStorage key name
   */
  removeItem: key => window[storageType].removeItem(key),
  clear: () => window[storageType].clear()
});

/**
 * @method updateSessionStorage
 * @description Util to access local storage API
 */
const updateSessionStorage = storageAPI('sessionStorage');

/**
 * @method updateLocalStorage
 * @description Util to access local storage API
 */
const updateLocalStorage = storageAPI('localStorage');

export { storageAPI, updateLocalStorage, updateSessionStorage };
